import React, { useEffect, useState } from 'react'
import KalenderSalesman from './KalenderSalesman'
import KalenderNonSalesman from './KalenderNonSalesman'
import axios from 'axios'
import apiUrl from '../../../configs/constant'
import { useToast } from '../../../components/ToastProvider'

export default function Kalender() {
  const { showToast } = useToast()
  const { token } = JSON.parse(localStorage.getItem('user')!)

  const [isSalesman, setIsSalesman] = useState<boolean | null>(null) // null = loading

  useEffect(() => {
    checkSalesmanData()
  }, [])

  const checkSalesmanData = async () => {
    try {
      const res = await axios.get(`${apiUrl.apiUrl}/omni/kalender/get-salesman-data`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      const data = res.data.data

      // kalau ada object → salesman, kalau null → non-salesman
      setIsSalesman(data !== null && typeof data === 'object' && 'id' in data)
    } catch (err) {
      showToast('Gagal memeriksa data salesman', 'error')
      setIsSalesman(false) // fallback ke all
    }
  }

  if (isSalesman === null) return null // loading

  return isSalesman ? <KalenderSalesman /> : <KalenderNonSalesman />
}
